<div class="flex flex-wrap h-full">
  <div
    class="hidden md:hidden lg:block lg:col-5 xl:col-5 p-0 relative video-container"
  >
    <auth-screen></auth-screen>
  </div>

  <div
    class="col-12 md:col-12 lg:hidden xl:hidden flex justify-content-center p-0"
  >
    <img class="mob-logo" [src]="images.blueLogo" alt="" />
  </div>
  <div
    class="col-12 md:col-12 lg:col-7 p-0 flex flex-column align-items-center lg:justify-content-center mt-8 lg:mt-0"
  >
    <div class="check-circle flex align-items-center justify-content-center">
      <i class="pi pi-check"></i>
    </div>
    <div class="mt-2 flex flex-column align-items-center">
      <div class="heading mb-2">{{ message }}</div>
      <div class="heading-tagline">
        Please click continue to logging into your account
      </div>
      <div class="mt-7 lg:px-8 w-full">
        <a [routerLink]="'/auth/login'">
          <button
            pButton
            class="w-full login-button"
            type="button"
            label="Continue"
          ></button>
        </a>
      </div>
    </div>
  </div>
</div>
